import { render, staticRenderFns } from "./ChangeOrganizationModal.vue?vue&type=template&id=7a2e0a78&"
import script from "./ChangeOrganizationModal.vue?vue&type=script&lang=js&"
export * from "./ChangeOrganizationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports